import { Divider } from "@mui/material";
import { FC } from "react";

export interface VariantProps {
  orientation?: "horizontal" | "vertical";
  flexItem?: boolean;
  variant?: "fullWidth" | "inset" | "middle";
  sx?: any;
  color?: string;
}

interface SalifyDividerDefaultProps extends VariantProps {}

const SalifyDividerDefault: FC<SalifyDividerDefaultProps> = ({
  orientation = "horizontal",
  flexItem = false,
  variant = "fullWidth",
  sx,
  color,
}) => {
  const dividerSx = {
    backgroundColor: color || "#E0E0E0",
    ...sx,
  };

  return <Divider orientation={orientation} flexItem={flexItem} variant={variant} sx={dividerSx} />;
};

SalifyDividerDefault.displayName = "SalifyDividerDefault";

export default SalifyDividerDefault;
